import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const UserActionTypes = {
  ACCEPT_LEADS_PASSING_PROGRAM: createSubtypes('user|acceptLeadsPassingProgram'),
  FETCH_USER_INFO: createSubtypes('user|fetchUserInfo'),
  UPDATE_USER_INFO: createSubtypes('user|updateUserInfo'),
};
